import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerPeriodosPlan = async (values) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/ObtenerPeriodosPlan",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ObtenerPeriodosPlan };
